import { useState } from 'react'
import { api, errorMessage, useQuery } from '../api.js'
import { Alert, Button, Field, Input, Panel } from '../components/ui.js'

const KINDS = [
  { key: 'kamatera', label: 'Kamatera', note: 'Windows Server. API completa: energia, snapshot, redimensionamento.' },
  { key: 'hostinger', label: 'Hostinger', note: 'Linux. API completa de energia + metricas do provedor.' },
  { key: 'locaweb', label: 'Locaweb', note: 'Linux. API reduzida: leitura, reboot e snapshots. Confirme a autenticacao no primeiro teste.' },
] as const

export function AddProvider({ onAdded }: { onAdded: () => void }) {
  const [kind, setKind] = useState<(typeof KINDS)[number]['key']>('kamatera')
  const [label, setLabel] = useState('')
  const [values, setValues] = useState<Record<string, string>>({})
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const fields = useQuery(() => api.fleet.credentialFields.query(), [])

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await api.fleet.addProvider.mutate({ kind, label: label || kind, credentials: values })
      setValues({})
      setLabel('')
      onAdded()
    } catch (err) {
      setError(errorMessage(err))
    } finally {
      setBusy(false)
    }
  }

  const kindFields = fields.data?.[kind] ?? []

  return (
    <Panel title="Adicionar provedor">
      <form onSubmit={submit} className="max-w-lg space-y-4">
        <Field label="Provedor">
          <div className="grid gap-2">
            {KINDS.map((k) => (
              <label
                key={k.key}
                className={`flex cursor-pointer gap-3 rounded border p-3 text-sm ${
                  kind === k.key ? 'border-accent bg-accent-soft' : 'border-line'
                }`}
              >
                <input
                  type="radio"
                  name="kind"
                  checked={kind === k.key}
                  onChange={() => { setKind(k.key); setValues({}) }}
                  className="mt-1"
                />
                <span>
                  <span className="font-medium">{k.label}</span>
                  <span className="mt-0.5 block text-xs text-ink-3">{k.note}</span>
                </span>
              </label>
            ))}
          </div>
        </Field>

        <Field label="Apelido" hint="Como este provedor aparece nas telas. Ex.: “Kamatera — produção”.">
          <Input value={label} onChange={(e) => setLabel(e.target.value)} placeholder={kind} />
        </Field>

        {kindFields.map((f) => (
          <Field key={f.key} label={f.label}>
            <Input
              type={f.secret ? 'password' : 'text'}
              value={values[f.key] ?? ''}
              onChange={(e) => setValues({ ...values, [f.key]: e.target.value })}
              autoComplete="off"
            />
          </Field>
        ))}

        {error && <Alert>{error}</Alert>}

        <p className="text-xs text-ink-3">
          A credencial e testada com uma chamada de leitura antes de ser gravada, e vai para o cofre
          cifrada em envelope. Nenhuma tela do painel mostra o valor depois disso.
        </p>

        <Button type="submit" variant="primary" disabled={busy}>
          {busy ? 'Testando credencial...' : 'Testar e cadastrar'}
        </Button>
      </form>
    </Panel>
  )
}
